import { deleteEmployeeStatus } from "../../../../../actions/Utilities/EmployeeStatus";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteEmployeeStatus = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteEmployeeStatus(ids), {
    onSuccess: (res) => {
      queryClient.invalidateQueries(["GetEmployeeStatus"]);
      toast.fire(
        "Success",
        "Employee Status were deactivated successfully",
        "success"
      );
    },
    onError: (error) => {
      toast.fire(
        "Bulk deactivation of Employee Status failed",
        "Server Error: Cannot deactivate Employee Status",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteEmployeeStatus;
